export default __webpack_public_path__ + "static/media/search_error.dba0ba40.svg";